import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-icon-text-badge',
  templateUrl: './icon-text-badge.component.html',
  styleUrls: ['./icon-text-badge.component.scss']
})
export class IconTextBadgeComponent implements OnInit {

  @Input() iconName!: string; // as describe in the shared/icon.module.ts file.
  @Input() text!: string; // as 'frjson.textattribute' for the translation pipe.

  constructor() { }

  ngOnInit(): void {
  }

}
